export const questions = [
  {
    id: 1,
    text: '¿Cuál es tu edad?',
    options: ['35 a 44 años', '45 a 54 años', '55 años o más'],
  },
  {
    id: 2,
    text: '¿En qué etapa te encuentras?',
    options: [
      'Perimenopausia — mis ciclos son irregulares',
      'Menopausia — ya no tengo mi período',
      'Postmenopausia — pasó hace más de un año',
      'No estoy segura — solo sé que algo cambió',
    ],
  },
  {
    id: 3,
    text: '¿Cómo es tu sueño en este momento?',
    options: [
      'Bochornos nocturnos que me despiertan empapada',
      'Me despierto varias veces y no logro volver a dormir',
      'Duermo pero no descanso — me levanto agotada',
      'Duermo bien — no es mi mayor problema',
    ],
  },
  {
    id: 4,
    text: '¿Qué es lo que más extrañas de la mujer que eras antes de que todo esto empezara?',
    options: [
      'Mi energía — podía con todo y ahora soy un fantasma',
      'Mi claridad mental — antes era ágil, ahora me pierdo',
      'Mi cuerpo — me reconocía en el espejo, hoy no',
      'Mi estabilidad — ya no sé quién soy ni qué quiero',
    ],
  },
  {
    id: 5,
    text: '¿Qué síntoma te está robando más la vida en este momento?',
    options: [
      'Niebla mental — me siento torpe y olvidadiza',
      'Cambios de humor — lloro o exploto sin razón',
      'Cansancio extremo — nada me da energía',
      'Todo junto — me siento irreconocible',
    ],
  },
  {
    id: 6,
    text: '¿Crees que tu cuerpo todavía puede repararse a sí mismo si recibe la señal correcta?',
    options: [
      'Sí — mi cuerpo es sabio, solo necesita la señal correcta',
      'Quiero creerlo — pero ya intenté tanto que tengo miedo',
      'No sé — la esperanza se me está acabando',
      'Ya no sé qué pensar — nada ha funcionado',
    ],
  },
]
